import { attr, belongsTo } from '@ember-data/model';
import CatalogObject, { CatalogObjectType } from '@square/dashboard-items-data/models/connect/catalog-object';
import { CatalogObjectType as CatalogObjectTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
export default CatalogObject.extend({
  type: attr('string', {
    defaultValue: CatalogObjectType.SERVICE_CHARGE,
    protoEnum: CatalogObjectTypeProto
  }),
  serviceChargeData: belongsTo('connect/service-charge/data', {
    async: false
  })
});